import React, { Component } from 'react';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'span';
}
export function Reveal({
  children,
  className = '',
  as = 'div'
}: RevealProps) {
  const Component = as as any;
  return <Component className={className} data-id="element-1844">{children}</Component>;
}